module.exports = __webpack_public_path__ + "img/grow-bg.388cbae2.jpg";